var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mat-image"}},[_c('img',{ref:"img",style:(_vm.style),attrs:{"data-src":_vm.lazySrc,"data-srcset":_vm.lazySrcset}}),_c('i',{ref:"erroricon",staticClass:"el-icon-picture-outline erroricon"})])}
var staticRenderFns = []

export { render, staticRenderFns }